import React, { Component } from 'react'
import { Spin } from 'antd'

class Loading extends Component {
  render() {
    return (
      <div style={{
        textAlign: 'center',
        borderRadius: '4px',
        marginBottom: '20px',
        padding: '30px 50px',
        margin: '20px 0'
      }}>
        <Spin />
      </div>
    )
  }
}

export default Loading
